import { InjectionToken } from '@angular/core';
import { FormControl } from '@angular/forms';

/** Interface for the parent dropdown, used to break the circular dependency. */
export interface ICeDropdownComponent {
    control: FormControl;
}

/**
 * Injection token used by `CeDropdownOptionComponent` to access its parent dropdown
 * without creating a circular module dependency.
 */
export const CE_DROPDOWN_COMPONENT = new InjectionToken<ICeDropdownComponent>('CeDropdownComponent');
